// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerDetails from './customer-details';
import CustomerSearchModal from '../../../product/shared/components/customer-search-2/customer-search-2-modal';
import {FormattedMessage} from 'react-intl';

function handleEditCustomerClick() {

    this.updateCustomerEditModalVisibility(true);

}

function handleClick() {

    this.updateCustomerSearchModalVisibility(true);

}

function handleCustomerSearchModalClose() {

    this.updateCustomerSearchModalVisibility(false);
    this.updateCustomerEditModalVisibility(false);

}

const CustomerSearch2Panel = props =>
    <div className='customer-search-panel'>
        <div className='customer-details-panel'>
            <label>
                <FormattedMessage id='CUSTOMER'/>
            </label>
            <div className='customer-details'>
                {props.customer.displayName ?
                    <CustomerDetails
                        customer={props.customer}
                        onEditCustomer={props::handleEditCustomerClick}
                    /> :
                        <span className='error'>
                            <FormattedMessage id='NO_CUSTOMER_SELECTED'/>
                        </span>
                }
                <div
                    className='find-customer-link'
                    onClick={props::handleClick}
                >
                    <FormattedMessage id='FIND_CUSTOMER'/>
                </div>
            </div>
        </div>
        <CustomerSearchModal
            customer={props.customer}
            isOpen={(props.isCustomerSearchModalOpen || props.isCustomerEditModalOpen)}
            onClose={props::handleCustomerSearchModalClose}
            onCustomerCreate={props.onCreateCustomerClick}
            route={props.isCustomerEditModalOpen ? 'EDIT_CUSTOMER' : 'CUSTOMER_SEARCH'}
        />
    </div>;

CustomerSearch2Panel.displayName = 'CustomerSearch2Panel';
CustomerSearch2Panel.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    isCustomerEditModalOpen: PropTypes.bool.isRequired,
    isCustomerSearchModalOpen: PropTypes.bool.isRequired,
    onCreateCustomerClick: PropTypes.func.isRequired,
    onCustomerEdit: PropTypes.func.isRequired,
    updateCustomerEditModalVisibility: PropTypes.func.isRequired,
    updateCustomerSearchModalVisibility: PropTypes.func.isRequired
};

export default CustomerSearch2Panel;



// WEBPACK FOOTER //
// ./src/shared/components/customer-search-panel/customer-search-2.js